import io from 'socket.io-client'
const debug = require('../data/debug_mode')
const url = debug === true ? 'http://localhost:5002' : 'https://delpacargo.delpasystem.com'
let socket = io(url)
export default  socket